import React, {useEffect, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {getProfileMe, getProfileNotifications} from '../../redux/actions/profile/profileActions';
import './Header.scss';
import ButtonMUI from '../../shared/ButtonMUI';
import {ReactComponent as PlusIcon} from '../../assets/icons/plus.svg';
import {ReactComponent as Bell} from '../../assets/icons/bell.svg';
import {ReactComponent as ProjectIcon} from '../../assets/icons/project.svg';
import {ReactComponent as MessageIcon} from '../../assets/icons/mail.svg';
import {ReactComponent as LogoShort} from '../../assets/images/header/logo.svg';
import {setModal, setSiteLoaded} from '../../redux/actions/app/appActions';
import {POPUPS} from '../../redux/actions/app/appActionTypes';
import {Link, NavLink} from 'react-router-dom';
import {mainPath} from '../../routes/paths';
import {notifyError} from '../../helpers/notifySnack';
import {hasPermission} from '../../helpers/functions';
import {PERMISSIONS} from '../../helpers/constants';
import {getCompanies} from '../../redux/actions/company/companyActions';
import {getProjects} from '../../redux/actions/projects/projectsActions';
import {getEmployeeForReview} from '../../redux/actions/employee/employeeActions';
import {IconButtonMUI} from "../../shared";
import Count from "../../features/Components/Count";

const Header = () => {
    const dispatch = useDispatch();
    const {t, i18n} = useTranslation();
    const {profileMe, loading,notificationsNewCount} = useSelector((state) => state.profile);
    const companyList = useSelector(({company}) => company.companies);
    const hasFetched = useRef(false);

    useEffect(() => {
        if (localStorage.getItem('token')) {
            dispatch(getProfileNotifications(1,true))
            dispatch(getProfileMe());
        }
    }, [dispatch]);

    useEffect(() => {
        if (!hasFetched.current && profileMe?.permissions) {
            hasFetched.current = true;

            const fetchFunc = async () => {
                if (hasPermission(PERMISSIONS.COMPANY_READ, profileMe?.permissions)) {
                    await dispatch(getCompanies());
                }
                if (hasPermission(PERMISSIONS.EMPLOYEE_REVIEW, profileMe?.permissions)) {
                    await dispatch(getEmployeeForReview());

                    if (profileMe?.needReview === true) {
                        dispatch(setModal(POPUPS.REVIEW_POPUP));
                    }
                }
                await dispatch(getProjects());
                dispatch(setSiteLoaded());
                hasFetched.current = false
            };
            fetchFunc();
        }
    }, [profileMe?.permissions]);

    useEffect(() => {
        if (!loading && profileMe?.language) {
            const supportedLanguages = ['en', 'uk', 'ru'];
            const language = supportedLanguages.includes(profileMe.language) ? profileMe.language : 'uk';
            i18n.changeLanguage(language);
            localStorage.setItem('langD', language);
        }
    }, [profileMe?.language, loading, i18n]);

    const handleProjectsAdd = () => {
        if (companyList.length > 0) {
            return dispatch(setModal(POPUPS.PROJECT_POPUP));
        }
        return notifyError('Для початку додайте компанію');
    };

    const handleCompanyAdd = () => {
        dispatch(setModal(POPUPS.COMPANY_POPUP));
    };

    return (
        <header className='header'>
            <div className='header__container'>
                <NavLink to={mainPath.home} className='header__logo'>
                    <LogoShort/>
                </NavLink>
                <div className='header__buttons'>
                    {hasPermission(PERMISSIONS.PROJECT_CREATE, profileMe?.permissions ?? []) && (
                        <ButtonMUI startIcon={<ProjectIcon/>} onClick={handleProjectsAdd}>
                            <span className={'button-text'}>{t('header.project')}</span>
                        </ButtonMUI>
                    )}

                    {hasPermission(PERMISSIONS.COMPANY_CREATE, profileMe?.permissions ?? []) && (
                        <ButtonMUI color={'primary'} startIcon={<PlusIcon/>} onClick={handleCompanyAdd}>
                            <span className={'button-text'}>{t('header.company')}</span>
                        </ButtonMUI>
                    )}
                    {hasPermission(PERMISSIONS.SENDING_NEWSLETTERS, profileMe?.permissions ?? []) && (
                        <ButtonMUI component={Link} to={mainPath.archive} color={'secondary'} startIcon={<MessageIcon/>}>
                            <span className={'button-text'}>{t('header.mailing')}</span>
                        </ButtonMUI>
                    )}
                    <div className={'button-bell'}>
                        <IconButtonMUI size={'medium'} color={'default'} component={Link} to={mainPath.notifications}>
                            <Bell/>
                        </IconButtonMUI>
                        {notificationsNewCount > 0 && <Count count={notificationsNewCount} color={'blue'} size={'xxs'} hasPlus={true} limit={99}/>}

                    </div>

                </div>
            </div>
        </header>
    );
};

export default Header;
